var support = /** @class */ (function () {
    function support() {
    }
    support.STORE_MODULE_NAME = 'support';
    return support;
}());
export { support };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/support/lib/support.cls.ts
// module id = null
// module chunks = 